import { render } from "./ViewImageListComponent.vue?vue&type=template&id=af5bcb5a"
import script from "./ViewImageListComponent.vue?vue&type=script&lang=js"
export * from "./ViewImageListComponent.vue?vue&type=script&lang=js"
script.render = render

export default script